module.exports = __webpack_public_path__ + "static/img/airplane@3x.61a261f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/instantprice/airplane@3x.png
// module id = zsug
// module chunks = 0